import { downloadFile } from '@/services/axios/dowload-file';
import { RunComponentCommonProps } from '@/types/run-components.type';

export default function RunImageGroupComponent({
  componentMapping
}: RunComponentCommonProps) {
  return (
    <div>
      {componentMapping?.component_image_group?.component_images &&
        componentMapping?.component_image_group?.component_images?.length >
          0 && (
          <div className="flex flex-col gap-2">
            {componentMapping?.component_image_group?.component_images.map(
              (componentImage, index) => (
                <div
                  key={index}
                  className="flex max-w-full md:max-w-[65%] items-center justify-between border border-gray-400 rounded-md bg-white"
                >
                  <div className="flex w-full flex-col">
                    <div className="flex flex-row border-b border-gray-400">
                      {/* SVG Icon */}
                      <div className="flex items-center p-2 border-r border-gray-400 rounded-tl-md bg-[#ffb9ff]">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.94853 11.2038H11.1241C11.2309 11.2038 11.3066 11.1583 11.351 11.0673C11.3955 10.9762 11.3844 10.8884 11.3177 10.8038L9.64976 8.58845C9.59848 8.52178 9.53396 8.48845 9.45618 8.48845C9.3784 8.48845 9.31387 8.52178 9.26259 8.58845L7.44209 10.8961L6.27159 9.36023C6.21439 9.29356 6.14732 9.2613 6.07036 9.26345C5.9934 9.26558 5.92928 9.29998 5.87799 9.36665L4.76519 10.8038C4.70964 10.8927 4.7013 10.9816 4.74019 11.0705C4.77908 11.1594 4.84853 11.2038 4.94853 11.2038ZM3.29724 13.6666C3.03581 13.6666 2.81019 13.5717 2.62039 13.3819C2.43059 13.1921 2.33569 12.9665 2.33569 12.7051V3.29486C2.33569 3.03343 2.43059 2.80781 2.62039 2.61801C2.81019 2.42821 3.03581 2.33331 3.29724 2.33331H12.7074C12.9689 2.33331 13.1945 2.42821 13.3843 2.61801C13.5741 2.80781 13.669 3.03343 13.669 3.29486V12.7051C13.669 12.9665 13.5741 13.1921 13.3843 13.3819C13.1945 13.5717 12.9689 13.6666 12.7074 13.6666H3.29724ZM3.29724 12.9102H12.7074C12.7587 12.9102 12.8057 12.8888 12.8485 12.8461C12.8912 12.8034 12.9126 12.7564 12.9126 12.7051V3.29486C12.9126 3.24357 12.8912 3.19656 12.8485 3.15381C12.8057 3.11108 12.7587 3.08971 12.7074 3.08971H3.29724C3.24595 3.08971 3.19894 3.11108 3.15619 3.15381C3.11346 3.19656 3.09209 3.24357 3.09209 3.29486V12.7051C3.09209 12.7564 3.11346 12.8034 3.15619 12.8461C3.19894 12.8888 3.24595 12.9102 3.29724 12.9102Z"
                            fill="black"
                            fillOpacity="0.6"
                          />
                        </svg>
                      </div>

                      <div className="flex w-full justify-between items-center">
                        {/* Image Name */}
                        <div className="flex-1 pl-2">
                          {componentImage?.alt_text || ''}
                        </div>

                        {/* Download Button */}
                        {/* <div className="flex-shrink-0 pr-2">
                          {componentImage?.url && (
                            <CLTooltip content="View Image" position="right">
                              <button
                                className="bg-[#ffa726] p-0.5 rounded-full"
                                onClick={() => {
                                  downloadFile(
                                    componentImage?.url as string,
                                    (componentImage?.alt_text ||
                                      'default-alt-text') as string
                                  );
                                }}
                              >
                                <svg
                                  width="56"
                                  height="56"
                                  viewBox="0 0 56 56"
                                  fill="none"
                                  style={{ width: '12px', height: '12px' }}
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M2.3335 28.0002C2.3335 28.0002 11.6668 9.3335 28.0002 9.3335C44.3335 9.3335 53.6668 28.0002 53.6668 28.0002C53.6668 28.0002 44.3335 46.6668 28.0002 46.6668C11.6668 46.6668 2.3335 28.0002 2.3335 28.0002Z"
                                    stroke="black"
                                    stroke-width="4"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M28 35C31.866 35 35 31.866 35 28C35 24.134 31.866 21 28 21C24.134 21 21 24.134 21 28C21 31.866 24.134 35 28 35Z"
                                    stroke="black"
                                    stroke-width="4"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </button>
                            </CLTooltip>
                          )}
                        </div> */}
                      </div>
                    </div>

                    {/* Image */}
                    <div className="p-2">
                      {componentImage?.url && (
                        <img
                          className="rounded-lg max-w-full cursor-pointer"
                          src={componentImage.url}
                          alt={componentImage?.alt_text || 'Image'}
                          onClick={() => {
                            downloadFile(
                              componentImage?.url as string,
                              (componentImage?.alt_text ||
                                'default-alt-text') as string
                            );
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        )}
    </div>
  );
}
